import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/service';
import { apiUrl } from 'src/app/shared/services/api-url';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';

@Component({
  selector: 'app-capitals',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  hasSentMail: boolean = false;
  email: string;
  emailForm!: FormGroup;
  passwordForm!: FormGroup;
  isForgotEmail:boolean = false;
  isSpinner: boolean = false;
  isConfirmMode: boolean = false;
  uid: string = '';
  token: string = '';
  passwordVisible = false;
  confirmPasswordVisible = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private apiService: AuthService,
    private notification: NotificationService,
    private translate: TranslatePipe

  ) {
    this.email = '';
  }

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
    });
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, { validators: ForgotPasswordComponent.passwordsMatch });

    this.activatedRoute.queryParams.subscribe(params => {
      this.uid = ((params && (params.uid || params.uidb64)) || '').toString().trim();
      this.token = ((params && params.token) || '').toString().trim();
      this.isConfirmMode = !!(this.uid && this.token);
    });
  }

  static passwordsMatch(group: AbstractControl): ValidationErrors | null {
    const passwordControl = group.get('password');
    const confirmControl = group.get('confirmPassword');
    const password = passwordControl ? passwordControl.value : '';
    const confirmPassword = confirmControl ? confirmControl.value : '';
    if (!confirmPassword) {
      return null;
    }
    return password === confirmPassword ? null : { mismatch: true };
  }

  get confirmPasswordDirty(): boolean {
    const control = this.passwordForm.get('confirmPassword');
    return !!(control && control.dirty);
  }

  forgotEmail(): void {
    this.isForgotEmail = true;
  }

  submitForm(): void {
    for (const i in this.emailForm.controls) {
      this.emailForm.controls[i].markAsDirty();
      this.emailForm.controls[i].updateValueAndValidity();
    }
    if (this.emailForm.value.email != '') {
      this.resetPassword(this.emailForm.value.email);
    }
  }

  submitPasswordForm(): void {
    for (const i in this.passwordForm.controls) {
      this.passwordForm.controls[i].markAsDirty();
      this.passwordForm.controls[i].updateValueAndValidity();
    }
    this.passwordForm.updateValueAndValidity();
    if (this.passwordForm.invalid) {
      return;
    }
    this.confirmResetPassword(this.passwordForm.value.password, this.passwordForm.value.confirmPassword);
  }

  resetPassword(email: string): void {
    var data = {
      email: email,
    };
    this.isSpinner = true;
    this.apiService
      .ServerPostLogin(apiUrl.resetPassword, data)
      .subscribe((res: any) => {
        this.hasSentMail = true;
        this.isSpinner = false;
      },(err: any) => {
        this.notification.sendNotification(this.translate.transform('noSendEmail'), 'error');
        this.isSpinner = false;
      });
  }

  confirmResetPassword(password: string, confirmPassword: string): void {
    const data = {
      uid: this.uid,
      token: this.token,
      new_password: password,
      new_password1: password,
      new_password2: confirmPassword,
    };
    this.isSpinner = true;
    this.apiService
      .ServerPostLogin(apiUrl.resetPasswordConfirm, data)
      .subscribe((res: any) => {
        this.isSpinner = false;
        this.notification.sendNotification(this.translate.transform('resetPasswordSuccess'), 'success');
        this.router.navigate(['/login']);
      },(err: any) => {
        this.isSpinner = false;
        this.notification.sendNotification(this.translate.transform('resetPasswordError'), 'error');
      });
  }
}
